<!-- page-template-list.component.html -->

<div class="ptl-wrapper">

  <div class="cc-page-header">
    <div class="cc-page-header-title">
      <i class="pi pi-table"></i>
      <span>{{ 'PAGE.LIST_TITLE' | translate }}</span>
    </div>
    <div class="cc-page-header-actions">
      <p-button
        icon="pi pi-upload"
        [label]="'PAGE.IMPORT' | translate"
        severity="secondary"
        size="small"
        (click)="openImportDialog()"
      ></p-button>
      <p-button
        icon="pi pi-plus"
        [label]="'PAGE.ADD' | translate"
        severity="primary"
        size="small"
        (click)="createTemplate()"
      ></p-button>
    </div>
  </div>

  <div class="ptl-grid">
    <div class="ptl-card" *ngFor="let item of dataTable">
      <div class="ptl-card-preview">
        <app-page-template-example
          [cols]="item.columns"
          [rows]="item.rows"
          [cells]="item.cells"
          [imageSrc]="item.imageData"
        ></app-page-template-example>
      </div>
      <div class="ptl-card-body">
        <p class="ptl-card-name">{{ item.name }}</p>
        <div class="ptl-card-meta">
          <span>{{ item.columns }} col · {{ item.rows }} fil · {{ item.cells.length }} celdas</span>
        </div>
      </div>
      <div class="ptl-card-actions">
        <p-button
          icon="pi pi-download"
          size="small"
          [text]="true"
          severity="secondary"
          [pTooltip]="'PAGE.EXPORT' | translate"
          tooltipPosition="top"
          (click)="exportTemplate(item.id, item.name)"
        ></p-button>
        <p-button
          icon="pi pi-pencil"
          size="small"
          [text]="true"
          severity="secondary"
          [pTooltip]="'PAGE.EDIT' | translate"
          tooltipPosition="top"
          (onClick)="editTemplate(item.id)"
        ></p-button>
        <p-button
          icon="pi pi-copy"
          size="small"
          [text]="true"
          severity="secondary"
          [pTooltip]="'PAGE.CLONE' | translate"
          tooltipPosition="top"
          (click)="cloneTemplate(item.id)"
        ></p-button>
        <p-button
          icon="pi pi-trash"
          size="small"
          [text]="true"
          severity="danger"
          [pTooltip]="'PAGE.REMOVE' | translate"
          tooltipPosition="top"
          (click)="removeTemplate(item.id)"
        ></p-button>
      </div>
    </div>
  </div>

  <div class="list-empty-state" *ngIf="!dataTable || dataTable.length === 0">
    <i class="pi pi-table"></i>
    <p>{{ 'PAGE.EMPTY_MSG' | translate }}</p>
    <p-button
      icon="pi pi-plus"
      [label]="'PAGE.ADD' | translate"
      severity="primary"
      size="small"
      (click)="createTemplate()"
    ></p-button>
  </div>

</div>

<p-confirmDialog
  key="pageTemplateConfirm"
  [position]="'center'"
  rejectButtonStyleClass="'p-button-danger'"
></p-confirmDialog>

<app-page-template-in-use
  [displayDialog]="displayDialog"
  [templateInuse]="templateInuse"
  (dialogClosed)="closeDialog()"
></app-page-template-in-use>

<app-page-template-import-dialog
  [(visible)]="showImportDialog"
  (imported)="onTemplateImported($event)"
></app-page-template-import-dialog>
